




export const CHANGE_USERNAME = 'boilerplate/Home/CHANGE_USERNAME';
export const ON_CALL_UPLOAD = 'boilerplate/Landing/ON_CALL_UPLOAD';
export const FAILED_INV_VAL = 'boilderplate/ManagePassInv/FAILED_INV_VAL'
export const RESET_FETCH_FAILED = 'boilerplate/ManagePassInv/RESET_FETCH_FAILED'
export const ON_NOTIFY = 'boilerplate/ManagePassInv/ON_NOTIFY'
export const LOADER_STATUS = 'boilerplate/ManagePassInv/LOADER_STATUS'
export const TOTAL_RECORD = 'boilerplate/ManagePassInv/TOTAL_RECORD'
export const GET_ITEM = 'boilderplate/ManagePassInv/GET_ITEM'
export const TOTAL_ITEM_RECORDS = 'boilderplate/ManagePassInv/TOTAL_ITEM_RECORDS'
export const TXN_RECORD = 'biolderplate/ManagePassInv/TXN_RECORD'
export const SET_PAGE_PAGE = 'boilerplate/ManagePassInv/SET_PAGE_PAGE'
export const SET_ITEMS_ERROR = 'boilerplate/ManagePassInv/SET_ITEMS_ERROR'
